//App.js => default

//Appel autres fichiers
var $ = require('jquery');
window.$ = window.jQuery = $;

//Appel Boostrap
require('bootstrap');

//Autres fichiers
require('./elements/appearlazy');
require('./elements/lazysizes');
require('./elements/HeaderSticky');
require('./elements/HeaderHub');
require('./elements/FooterSticky');

const iframeUrl = document.querySelector('meta[name="url-suivi-iframe"]').getAttribute('content');

//Iframe
/*const getGeneratedPageURL = ({
    html,
    css,
    js
}) => {
    const getBlobURL = (code, type) => {
        const blob = new Blob([code], {
            type
        })
        return URL.createObjectURL(blob)
    }

    const cssURL = getBlobURL(css, 'text/css')
    const jsURL = getBlobURL(js, 'text/javascript')

    const source = `
      <html>
        <head>
            ${css && `<link rel="stylesheet" type="text/css" href="${cssURL}" />`}
            ${js && `<script src="${jsURL}"></script>`}
        </head>
        <body>
          ${html || ''}
        </body>
      </html>
    `

    return getBlobURL(source, 'text/html')
}

const url = getGeneratedPageURL({
    html:
    '<div class="container_login_suivi">' +
        '<form action="'+iframeUrl+'process.do" method="POST" data-bitwarden-watching="1">' +
            '<input type="hidden" name="" value="">' +
            '<div class="form-group mb-4">' +
                '<input class="form-control" type="email" name="username" placeholder="Text is required" required />' +
                '<label class="form-label">Email</label>' +
            '</div>' +
            '<div class="form-group mb-4">' +
                '<input class="form-control" type="password" name="password" placeholder="Text is required" required="">' +
                '<label class="form-label">Votre mot de passe</label>' +
                '<small><a href="/protexiaAuth/loginResetPage.do">Mot de passe oublié ?</a></small>' +
            '</div>' +
            '<div class="">' +
                '<button class="submit" type="submit">Connexion <i class="bi bi-arrow-right right ms-2"></i></button>' +
            '</div>' +
        '</form>' +
    '</div>',
    css:
        'body {' +
            'margin: 0;' +
        '}'+
        '.container_login_suivi {' +
            'padding-top: 2rem;' +
        '}'+
        '.container_login_suivi .form-group {' +
            'position: relative;' +
            'color: #666;' +
            'font-size: 15px;' +
            'margin-bottom: 2rem;' +
        '}'+
        '.container_login_suivi .form-group a {' +
            'color: #414141;' +
            'font-family: "AllianzNeo", sans-serif;' +
            'margin-top: 8px;' +
            'display: block;' +
        '}'+
        '.container_login_suivi .form-group .form-control {' +
            'width: 100%;' +
            'position: relative;' +
            'z-index: 3;' +
            'background: none;' +
            'border: none;' +
            'padding: 5px 0;' +
            'transition: transform 0.3s ease;' +
            'color: #075994;' +
            'font-family: "AllianzNeoBold", sans-serif;' +
            'border-radius: 0;' +
            'font-size: 22px;' +
            'border-bottom: 1px solid #414141;'+
            'display: block;'+
            'font-weight: 400;'+
            'line-height: 1.6;'+
            'appearance: none;'+
            'margin: 0;'+
        '}'+
        '.container_login_suivi .form-group .form-control:focus {' +
            'outline: none;' +
            'box-shadow: none;' +
            'border-color: #075994;' +
        '}'+
        '.container_login_suivi .form-group .form-control::placeholder {' +
            'color: transparent !important;' +
        '}'+
        '.container_login_suivi .form-group .form-control:focus + .form-label {' +
            'font-size: 14px;' +
            'font-family: "AllianzNeoSemiBold", sans-serif;' +
            'transform: translateY(-25px);' +
        '}'+
        '.container_login_suivi .form-group .form-label {' +
            'position: absolute;' +
            'z-index: 1;' +
            'left: 0;' +
            'top: 10px;' +
            'transition: 0.3s !important;' +
            'color: #414141;' +
            'font-family: "AllianzNeoLight", sans-serif;' +
            'font-size: 16px;' +
            'display: inline-block;'+
            'font-weight: 300;'+
            'margin-bottom: 0.5rem;'+
        '}'+
        '.container_login_suivi .form-group .form-control:not(:placeholder-shown):not(:placeholder-shown) + .form-label {' +
            'font-size: 14px;' +
            'font-family: "AllianzNeoSemiBold", sans-serif;' +
            'transform: translateY(-25px);' +
        '}'+
        '.container_login_suivi .submit {' +
            'border: 1px solid #075994;' +
            'cursor: pointer;' +
            'transition: all 0.33s !important;' +
            'color: #075994;' +
            'border-radius: 0.375rem !important;' +
            'padding: 0.375rem 0.75rem;' +
            'font-family: "AllianzNeo", sans-serif;' +
            'background-color: transparent;' +
            'display: inline-block;' +
            'font-size: 0.9rem;' +
            'font-weight: 400;' +
            'line-height: 1.6;' +
            'text-transform: uppercase;' +
        '}'+
        '.container_login_suivi .submit:hover {' +
            'color: #FFF;' +
            'background-color: #075994;' +
        '}'
    ,
    js: ''
})*/

//Loading
/*
const iframeEle = document.getElementById('iframe_connexion_suivi');
const loadingEle = document.getElementById('loading');

iframeEle.addEventListener('load', function () {
    // Hide the loading indicator
    loadingEle.style.display = 'none';

    // Bring the iframe back
    iframeEle.style.opacity = 1;

    iframeEle.style.height = iframeEle.contentWindow.document.documentElement.scrollHeight + 'px';
});
*/
//Is loaded
$('#iframe_connexion_suivi').ready(function(){
    const iframe = document.querySelector('#iframe_connexion_suivi')
    iframe.src = url
});

////////////////////////[AJOUT STYLE DANS UNE IFRAME]///////////////////////////
function onEvent(element, type, callback) {
    if (element.addEventListener) {  // W3C DOM
        element.addEventListener(type,callback,false);
    } else if (element.attachEvent) { // IE DOM
        element.attachEvent("on"+type, callback);
    } else { // Not much to do
        element["on"+type] = callback;
    }
}

function onMessage(callback) {
    onEvent(window, "message", function (msg) {
        if(window.location.hostname == 'mesdemarches.allianz.fr'){
            // production
            var urlPrima = 'https://primaprotexiaclaims.allianz.fr';
        } else {
            var urlPrima = 'https://primaprotexiaclaims-rf.allianz.fr';
        }
        if (!msg.isTrusted || msg.origin != urlPrima) {
            return;
        }
        callback(JSON.parse(msg.data).payload)
    });
}
//permet de récupérer le msg envoyer par l'iframe connexion suivi de dossier
onMessage(function (token) {
    let redirection = '/suivi/login/' + token;
    if(PARTENAIRE_URL != ''){
        redirection = '/' + PARTENAIRE_URL + redirection;
    }
    window.location.href = redirection;
});